import angular from 'angular';
export default function RoleViewDetailsController(
  $q,
  $stateParams,
  $log,
  $scope,
  $filter,
  $uibModal,
  usersService,
  RoleService,
  gettextCatalog,
) {
  'ngInject';

  let vm = this;
  // local scopes variables
  $scope.roleUsers = []; // all user in role
  $scope.filteredRoleUsers = [];
  $scope.roleUsersByPage = [];

  $scope.searchString = '';

  $scope.usersLoaded = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.successFlag = false;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = true;

  //Pagination
  $scope.current = {
    usersPage: 1,
  };
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  //Sort users in the role
  $scope.setPredicate = function (predicate, loading = false) {
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : false;
    $scope.predicate = predicate;
    if (!loading) GTM_UsersListChanged('roleUsersOrderChanged');
  };

  //applyFilter searchs on roleUsers[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredRoleUsers = $filter('filter')($scope.roleUsers, $scope.searchString);
    GTM_UsersListChanged('roleUsersFiltered');
  };

  // rest flages
  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  // function return true if any user selected for remove
  $scope.isAnyUserSelected = function () {
    let userhasremoveflag = $scope.roleUsers.filter(function (user) {
      return user.removeFlag;
    });

    return userhasremoveflag.length > 0 ? true : false;
  };

  //clicking on the row will taggel the removeFlag for the user
  $scope.toggleSelect = function (user) {
    $scope.resetFlags();
    if (user) {
      user.removeFlag = !user.removeFlag;
      GTM_UsersListChanged('roleUserSelectionChanged');
    }
  };

  // called after change happend to roleUsers to update the table
  let updateUserstable = function () {
    $scope.filteredRoleUsers = $scope.roleUsers.slice();
  };

  // watch seach then apply it
  $scope.$watch('searchString', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.applyFilter();
    }
  });

  // watch roleUsers then create model with remove fags
  $scope.$watch('roleUsers', function () {
    updateUserstable();
  });

  // function calls the api to get users that has the current role
  let loadRoleUsers = function () {
    $scope.loading = true;
    $scope.setPredicate($scope.predicate, true);

    RoleService.getAllUsersOfRole($stateParams.roleId).then(
      function (result) {
        $scope.roleUsers = result.data || [];
        $scope.loading = false;
      },
      function (error) {
        let errorMsg = gettextCatalog.getString('An error occurred when loading users');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.loading = false;
        $scope.roleUsers = [];
      },
    );
  };

  vm.$onInit = () => {
    const hasUsersfeature = usersService.hasRequiredFeatures(['admin.users']);
    if (hasUsersfeature) {
      //get users role
      loadRoleUsers();
    }
  };

  // open users model
  $scope.openSelectModal = function () {
    let roleName = $scope.$parent.roleData ? $scope.$parent.roleData.name : '';
    let modalScope = $scope.$new();
    modalScope.modalTitle = gettextCatalog.getString('Select users for Role : ') + roleName;
    modalScope.userCannotSelectHimself = true;

    $scope.resetFlags();
    let modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('../../../security-groups/view/users/users-modal/users.modal.html'),
      controller: 'SecurityGroupViewUserSelectionModalController',
      size: 'lg',
      scope: modalScope,
      resolve: {
        singleSelect: false,
        selectedUsers: function () {
          let selected = {};

          if ($scope.roleUsers) {
            for (let i = 0; i < $scope.roleUsers.length; i++) {
              let e = $scope.roleUsers[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
      },
    });
    // handle return result of users model
    modalInstance.result
      .then(function (selectedUsers) {
        let changes = [];
        let changeResult = $scope.roleUsers.slice() || [];
        for (let key in selectedUsers) {
          let alreadyPicked = false;
          for (let i = 0; i < $scope.roleUsers.length; i++) {
            if (key === $scope.roleUsers[i].id) {
              alreadyPicked = true;
              break;
            }
          }
          if (!alreadyPicked) {
            changeResult.push(selectedUsers[key]);
            $scope.applyChange(
              {
                op: 'add',
                value: {
                  userId: key,
                },
              },
              changes,
            );
          }
        }
        for (let i = 0; i < changeResult.length; i++) {
          let remove = true;
          for (let key in selectedUsers) {
            if (key === changeResult[i].id) {
              remove = false;
              break;
            }
          }
          if (remove) {
            $scope.applyChange(
              {
                op: 'remove',
                value: {
                  userId: changeResult[i].id,
                },
              },
              changes,
            );
            changeResult.splice(i, 1);
            i--;
          }
        }
        $scope.submitUsers(changeResult, changes);
      })
      .catch(() => {});
  };

  $scope.applyChange = function (newChange, changeset) {
    for (let i = 0; i < changeset.length; i++) {
      //handle behaviour when multiple changes requested for same resource
      if (changeset[i].value && changeset[i].value.userId === newChange.value.userId) {
        if (changeset[i].op === newChange.op) {
          //only apply one add or remove per resource
          return;
        } else {
          //if ops are different, changes will cancel out (ie. adding and removing a resource in the same request will have no net effect)
          changeset.splice(i, 1);
          return;
        }
      }
    }
    changeset.push(newChange);
  };

  // call on remove btn
  $scope.removeUsers = function () {
    let userToRemove = [];
    let newUserList = [];
    angular.forEach($scope.roleUsers, function (user) {
      if (user.removeFlag) {
        $scope.applyChange(
          {
            op: 'remove',
            value: {
              userId: user.id,
            },
          },
          userToRemove,
        );
      } else {
        newUserList.push(user);
      }
    });
    $scope.submitUsers(newUserList, userToRemove);
  };

  //  add or remov the current role from the selected users
  $scope.submitUsers = function (newUserList, changeset) {
    if (!changeset || changeset.length === 0) {
      return;
    }
    $scope.resetFlags();
    $scope.errorFlag = false;
    $scope.loading = true;
    let promises = [];

    angular.forEach(changeset, function (patchUser) {
      let promise = usersService.patchUserRoles(patchUser.value.userId, [
        {
          op: patchUser.op,
          roles: [
            {
              id: $stateParams.roleId,
            },
          ],
        },
      ]);
      promises.push(promise);
    });

    $q.all(promises).then(
      function () {
        if (newUserList) {
          $scope.roleUsers = newUserList.slice();
        }
        $scope.successFlag = true;
        $scope.loading = false;
        GTM_UsersListChanged('roleUsersLoaded');
      },
      function (error) {
        let errorMsg = gettextCatalog.getString('An error occurred while adding/removing users');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.loading = false;
      },
    );
    return true;
  }; // end submit users

  $scope.pageChanged = function () {
    GTM_UsersListChanged('roleUsersPageChanged');
  };

  function GTM_UsersListChanged(event) {
    let userhasremoveflag = $scope.roleUsers.filter(function (user) {
      return user.removeFlag;
    });
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.roleUsers,
        totalFiltered: $scope.filteredRoleUsers.length,
        totalSelected: userhasremoveflag.length,
        pageNumber: $scope.current.usersPage,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }
}
